import { render, staticRenderFns } from "./NuevaLiquidacion.vue?vue&type=template&id=d32a16de&scoped=true"
import script from "./NuevaLiquidacion.vue?vue&type=script&lang=js"
export * from "./NuevaLiquidacion.vue?vue&type=script&lang=js"
import style0 from "./NuevaLiquidacion.vue?vue&type=style&index=0&id=d32a16de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d32a16de",
  null
  
)

export default component.exports